<template>
  <div class="base-pagination">
    <BaseButton
      :disabled="isPreviousButtonDisabled"
      class="prev"
      @click.native="previousPage"
      v-scroll-to="{ el: '#app', offset: -100 }"
    >
      <!-- <img src="https://pointclickcare.com/wp-content/uploads/2020/06/arrow-right.svg" alt="previous" style="transform: scaleX(-1);" aria-hidden="true"> -->
      PREV
    </BaseButton>

    <BasePaginationTrigger
      v-for="paginationTrigger in paginationTriggers"
      :class="{
        'base-pagination__description--current':
          paginationTrigger === currentPage
      }"
      :key="paginationTrigger"
      :pageNumber="paginationTrigger"
      class="base-pagination__description"
      @loadPage="onLoadPage"
      v-scroll-to="{ el: '#app', offset: -100 }"
    />

    <BaseButton :disabled="isNextButtonDisabled" @click.native="nextPage"  v-scroll-to="{ el: '#app', offset: -100 }">
      NEXT
    </BaseButton>
  </div>
</template>

<script>
import BaseButton from "./BaseButton.vue";
import BasePaginationTrigger from "./BasePaginationTrigger.vue";

export default {
  components: {
    BaseButton,
    BasePaginationTrigger
  },

  props: {
    currentPage: {
      type: Number,
      required: true
    },

    pageCount: {
      type: Number,
      required: true
    },

    visiblePagesCount: {
      type: Number,
      default: 5
    }
  },

  computed: {
    isPreviousButtonDisabled() {
      return this.currentPage === 1;
    },

    isNextButtonDisabled() {
      return this.currentPage === this.pageCount;
    },

    paginationTriggers() {
      const currentPage = this.currentPage;
      const pageCount = this.pageCount;
      const visiblePagesCount = this.visiblePagesCount;
      const visiblePagesThreshold = (visiblePagesCount - 1) / 2;
      const pagintationTriggersArray = Array(pageCount - 1).fill(
        0
      );
      // const pagintationTriggersArray = Array(this.visiblePagesCount - 1).fill(
      //   0
      // );

      // case for only 1 page of results
      // if(pageCount == 1){
      //   // console.log('pageCount = 1');
      //   return [1];
      // }

      // Scenario 1: The selected page number is smaller than half of the list width      
      if (currentPage <= visiblePagesThreshold + 1) {
        pagintationTriggersArray[0] = 1;
        const pagintationTriggers = pagintationTriggersArray.map(
          (paginationTrigger, index) => {
            // console.log('case1');
            return pagintationTriggersArray[0] + index;
          }
        );

        pagintationTriggers.push(pageCount);

        return pagintationTriggers;
      }
      // Scenario 2: The selected page number is bigger than half of the list width counting from the end of the list
      if (currentPage >= pageCount - visiblePagesThreshold + 1) {
        const pagintationTriggers = pagintationTriggersArray.map(
          (paginationTrigger, index) => {
            // console.log('case2');
            return pageCount - index;
          }
        );

        pagintationTriggers.reverse().unshift(1);

        return pagintationTriggers;
      }
      // Scenario 3: All other cases
      pagintationTriggersArray[0] = currentPage - visiblePagesThreshold + 1;
      const pagintationTriggers = pagintationTriggersArray.map(
        (paginationTrigger, index) => {
          // console.log('case3');
          return pagintationTriggersArray[0] + index;
        }
      );

      pagintationTriggers.unshift(1);
      pagintationTriggers[pagintationTriggers.length - 1] = pageCount;

      return pagintationTriggers;
    }
  },
  methods: {
    nextPage() {
      this.$emit("nextPage");
    },

    onLoadPage(value) {
      this.$emit("loadPage", value);
    },

    previousPage() {
      this.$emit("previousPage");
    }
  }
};
</script>

<style lang="scss" scoped>
$c-primary-accent: #6a1b9a;

.base-pagination {
  display: flex;
  justify-content: center;
  align-items: center;

  &__description {
    display: flex;
    margin: 0 17px;
    font-size: 16px;
    font-weight: 400;
    color: $c-primary-accent;

    &--current {
      color: #212529;
    }

  }

  // .arrow-left {
  //   transform: rotateZ(180deg);
  // }
  // .arrow-left:after {
  //     content: " ";
  //     display: inline-block;
  //     border-right: 2px solid #2a7996;
  //     border-bottom: 2px solid #2a7996;
  //     width: 7px;
  //     height: 7px;
  //     -webkit-transform: rotate(-45deg);
  //     transform: rotate(-45deg);
  //     position: absolute;
  //     right: 0;
  //     top: 11px;
  // }
}
</style>
